export function isMobile() {
  return /Android|iPhone/i.test(navigator.userAgent);
}

export function hasSystemShare() {
  return !!navigator.share;
}
